<template>
  <div :class="className" :style="{height:height,width:width}"/>
</template>

<script>
import echarts from 'echarts' // echarts theme
import resize from './mixins/resize'
require('echarts/theme/macarons')

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getDay(day) {
      var today = new Date()

      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day

      today.setTime(targetday_milliseconds) // 注意，这行是关键代码

      var tYear = today.getFullYear()
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      return tYear + '-' + tMonth + '-' + tDate
    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = '0' + month
      }
      return m
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions({ expectedData } = {}) {
      let seriesDatas = []
      expectedData.data.map((i, index) => {
        seriesDatas.push({
          name: expectedData.legendData[index],
          type: 'line',
          smooth: true,
          animationDuration: 2800,
          animationEasing: 'cubicInOut',
          data: i,
        })
      })
      // console.log(seriesDatas)
      // let seriesDatas = {
      //   name: '邮件营销',
      //   type: 'line',
      //   stack: '总量',
      //   data: [120, 132, 101, 134, 90, 230, 210],
      // }
      this.chart.setOption({
        xAxis: {
          // data: [this.getDay(-15), this.getDay(-14), this.getDay(-13), this.getDay(-12), this.getDay(-11), this.getDay(-10), this.getDay(-9), this.getDay(-8), this.getDay(-7), this.getDay(-6), this.getDay(-5), this.getDay(-4), this.getDay(-3), this.getDay(-2), this.getDay(-1)],
          data: expectedData.date,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            rotate: 60,
          },
        },
        grid: {
          left: '2%',
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          padding: [5, 10],
        },
        yAxis: {
          axisTick: {
            show: false,
          },
        },
        legend: {
          data: expectedData.legendData,
        },
        // series: [{
        //   name: '每日新增',
        //   itemStyle: {
        //     normal: {
        //       color: '#FF005A',
        //       lineStyle: {
        //         color: '#FF005A',
        //         width: 2,
        //       },
        //     },
        //   },
        //   smooth: true,
        //   type: 'line',
        //   data: expectedData.data,
        //   animationDuration: 2800,
        //   animationEasing: 'cubicInOut',
        // }],
        series: seriesDatas,
      })
    },
  },
}
</script>
